<!-- <div id="cover-spin" ></div> -->
@if (!isPaymentRefund && !dlScanloaderRequest) {
  <div class="loaderIcon">
    <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
  </div>
}

@if (isPaymentRefund || isReversal || isEmvAutopay || isManualAutopay || userRiskDelay || dlScanloaderRequest || isReportGeneration) {
  <div class="loaderIcon"
    >
    <figure>
      <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
      @if ((isPaymentRefund && showPaymentMessage && !initiatedVoidCC) || (isManualAutopay && !processingUnit)) {
        <figcaption
        class="initiatedvoid">Transaction is in Progress. Please do not leave the page!</figcaption>
      }
      @if (isManualAutopay && processingUnit) {
        <figcaption align="center" class="initiatedvoid">Transaction is in
          Progress. Please do not leave the page!<br> Processing payment for Unit #: {{processingUnit}}</figcaption>
        }
        @if (initiatedVoidCC) {
          <figcaption class="initiatedvoid emvinitiatedvoid">Please check EMV Terminal Device!
          </figcaption>
        }
        @if (retryTransactionStatus) {
          <figcaption class="emvtransactionRetry">Payment is Not completed in the Terminal
          Device. Please complete before transaction is cancelled!</figcaption>
        }
        @if (userRiskDelay) {
          <figcaption class="initiatedvoid userRiskDelay">The Changes will be reflected in some
          time. Please verify after sometime!</figcaption>
        }
        @if (dlScanloaderRequest) {
          <figcaption class="initiatedvoid">DL Scanning is in Progress. Please wait for few
          seconds</figcaption>
        }
        @if (isReportGeneration) {
          <figcaption class="initiatedvoid">Report is getting Generated. Please do not leave
          the page!</figcaption>
        }
        @if (isTDEmv?.isTransactionWaitTime) {
          <figcaption class="initiatedvoid" style="left: 52%;">Please complete the
          transaction before - {{display}}</figcaption>
        }
        @if (isTDEmv?.isPortClosingWaitTime) {
          <figcaption class="initiatedvoid emvinitiatedvoid" style="left: 48.5%;">
          Please wait until the port is closed - {{display}}</figcaption>
        }
        @if (isTDEmv?.isVoidTransactionWaitTime) {
          <figcaption class="emvtransactionRetry"
            style="left: 46% !important;">Please Check EMV Terminal Device and Wait While Your Transaction is Processing
          - {{display}} </figcaption>
        }
        @if (stripeLoader?.isStripeterminal) {
          <div class="button-container" [ngClass]="{'button-padding': isTDEmv?.isVoidTransactionWaitTime}" [ngStyle] = "{'margin-left': initiatedStripEMVPayment ? '3rem' : 'none'}"
            >
            <button type="button" class="btn btn-primary statusButton" (click)="onStatusClick()">Status</button>
            <button type="button" class="cancelButton" (click)="onCancelClick()"
            [disabled]="isCancelledDisabled">Cancel</button>
          </div>
        }
        @if (initiatedStripEMVPayment) {
          <figcaption class="initiatedvoid emvinitiatedvoid">Please check EMV Terminal Device! - {{display}}</figcaption>
        }
      </figure>
    </div>
  }
